// Telas do acadêmico:
import { Academico } from './academico/pt-br'
import { AcademicoDiarioClasse } from './academico/diario-classe/pt-br'
import { AcademicoHome } from './academico/home/pt-br'
import { AcademicoGerenciamento } from './academico-gerenciamento/pt-br'
import { AcademicoMatriculas } from './academico/matriculas/pt-br'
import { AcademicoTurmas } from './academico/turmas/pt-br'
import { Admin } from './admin/pt-br'
import { FichaSaude } from './ficha-saude/pt-br'

// Telas de autentificação:
import { AutentificacaoLogin } from './autentificacao/login/pt-br'
import { AutentificacaoModalEsqueceuSenha } from './autentificacao/modal-esqueceu-senha/pt-br'
import { CamposValidacao } from './campos-validacao/pt-br'
import { Home } from './home/pt-br'

// Contábil:
import { Contabil } from './contabil/pt-br'
import { ContabilPlanoContas } from './contabil/plano-contas/pt-br'
import { ContabilFechamento } from './contabil/fechamento-contabil/pt-br'
import { ContabilLancamento } from './contabil/lancamentos/pt-br'

// Financeiro:
import { Financeiro } from './financeiro/pt-br'
import { FinanceiroLancamentos } from './financeiro/lancamentos/pt-br'
import { FinanceiroContasPagar } from './financeiro/contas-pagar/pt-br'
import { FinanceiroContasReceber } from './financeiro/contas-receber/pt-br'

import { Geral } from './geral/pt-br'
import { Menu } from './menu/pt-br'
import { PainelProfessor } from './painel-professor/pt-br'
import { Precos } from './precos/pt-br'
import { Perfis } from './perfis/pt-br'
import { Permissoes } from './permissoes/pt-br'
import { Pessoas } from './pessoas/pt-br'
import { Rh } from './rh/pt-br'
import { Usuarios } from './usuarios/pt-br'
import { CurriculoEscolar } from './curriculo-escolar/pt-br'
import { InstituicaoEnsino } from './curriculo-escolar/instituicao-ensino/pt-br'
import { ShortcutCards } from './shortcut-cards/pt-br'

// Suprimentos:
import { Suprimentos } from './suprimentos/pt-br'
import { SuprimentosLancamentosNF } from './suprimentos/lancamentos-nf/pt-br'
import { SuprimentosEstoque } from './suprimentos/estoque/pt-br'

export const br = {
  // Telas de admin:
  ADMIN: { ...Admin },

  // Telas do acadêmico:
  ACADEMICO: { ...Academico },
  ACADEMICO_DIARIO_CLASSE: { ...AcademicoDiarioClasse },
  ACADEMICO_HOME: { ...AcademicoHome },
  ACADEMICO_GERENCIAMENTO: { ...AcademicoGerenciamento },
  ACADEMICO_MATRICULAS: { ...AcademicoMatriculas },
  ACADEMICO_TURMAS: { ...AcademicoTurmas },
  FICHA_SAUDE: { ...FichaSaude },

  // Telas de autentificação
  AUTENTIFICACAO_LOGIN: { ...AutentificacaoLogin },
  AUTENTIFICACAO_MODAL_ESQUECEU_SENHA: { ...AutentificacaoModalEsqueceuSenha },

  // Contábil
  CONTABIL: { ...Contabil },
  CONTABIL_PLANO_CONTAS: { ...ContabilPlanoContas },
  CONTABIL_FECHAMENTO: { ...ContabilFechamento },
  CONTABIL_LANCAMENTO: { ...ContabilLancamento },

  CURRICULO_ESCOLAR: { ...CurriculoEscolar },
  INSTITUICAO_ENSINO: { ...InstituicaoEnsino },
  HOME: { ...Home },

  // Financeiro:
  FINANCEIRO: { ...Financeiro },
  FINANCEIRO_LANCAMENTOS: { ...FinanceiroLancamentos },
  FINANCEIRO_CONTAS_PAGAR: { ...FinanceiroContasPagar },
  FINANCEIRO_CONTAS_RECEBER: { ...FinanceiroContasReceber },

  USUARIOS: { ...Usuarios },
  PERMISSOES: { ...Permissoes },
  PERFIS: { ...Perfis },
  PESSOAS: { ...Pessoas },
  RH: { ...Rh },
  PRECOS: { ...Precos },
  TITULO: "",
  GERAL: { ...Geral },
  MENU: { ...Menu },
  CAMPOS_VALIDACAO: { ...CamposValidacao },
  PAINEL_PROFESSOR: { ...PainelProfessor },
  SHORTCUT_CARDS: { ...ShortcutCards },

  // Suprimentos:
  SUPRIMENTOS: { ...Suprimentos },
  SUPRIMENTOS_LANCAMENTOS_NF: { ...SuprimentosLancamentosNF },
  SUPRIMENTOS_ESTOQUE: { ...SuprimentosEstoque },
}